import * as React from "react";
import { Link } from "gatsby";
import PostCardPicture from "./PostCardPicture";
import PostCardCategories from "./PostCardCategories";
import { css } from "@emotion/css";

export default function PostCard(props) {


  const linkSlug =
    props.node.parentPage && props.node.parentPage.slug
      ? `/${props.node.parentPage.slug}/${props.node.slug}/`
      : `${props.node.slug}`;

    const categories = props.node.categories && props.node.categories.length > 0
        ? props.node.categories
        : ['Other'];

  return (
    <div className={postCard}>
      <Link to={linkSlug}>
        {/* Picture */}
        <PostCardPicture node={props.node} large={props.large} />
      </Link>

      {/* Categories */}
      {!props.simple && props.node.categories && <PostCardCategories categories={categories} />}

      {/* Title */}
      <Link to={linkSlug}>
        {!props.simple && !props.large && <strong dangerouslySetInnerHTML={{ __html: props.node.title }} />}
        {props.large && <div className="h3" dangerouslySetInnerHTML={{ __html: props.node.title }} />}
      </Link>
    </div>
  );
}

const postCard = css`
  a {
    color: #333;
    transition: color 150ms cubic-bezier(0, 0, 0.2, 1);
  }
  &:hover a {
    color: #ff7c16;
  }
`;
